import React from 'react'
export function Add_Network_Comp(){
    return(<div className="modal fade bd-example-modal-xl"  id="divNetWorkComp" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div className="modal-dialog modal-xlll" role="document">
      <div className="modal-content">
      <div className="modal-header bg-primary">
          <h5 className="modal-title text-white" id="exampleModalLabel">System Setup</h5>
          <button type="button" className="close text-white" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true" className="text-white">&times;</span>
          </button>
        </div>
        <form id="frmNetworkComp" name="frmNetworkComp">
       
        <div className="modal-body">
        <div className="row">
                  {/* <!-- left column --> */}
                  <div className="col-md-12">
                      <div className="card card-danger">
                              <input type="hidden" name="res_func" id="res_func" value="okFirstSetupResp" />
                              <input type="hidden" name="curl_type" id="curl_type" value="saveNetworkd" />
                              <input type="hidden" name="m_type" id="m_type" value="saveNetworkd" />
                              <input type="hidden" name="type_id" id="type_id" value="2" />
                              
                              <div className="card-body">
                                  <div className="row">
                                  <div className="col-lg-12 col-md-12">
                                          <div className="form-group">
                                              <label for="exampleInputEmail1">System Type</label>
                                              <div className="input-group input-group-sm">
                                                  <select id="system_type" name="system_type" className="form-control required12">
                                                  <option value="0">-Select-</option>
                                                  <option value="1">-Other System-</option>
                                                    <option value="2">-Main System-</option>
                                                    
                                                  </select>
                                              </div>
                                          </div>
                                      </div>
                                      {/* <div className="col-lg-12 col-md-12">
                                          <div className="form-group">
                                              <label for="exampleInputEmail1">Sys Name*</label>
                                              <div className="input-group input-group-sm">
                                                  <input type="text" id="sysname" name="sysname" className="form-control required" placeholder="" />
                                              </div>
                                          </div>
                                      </div> */}
                                      <div className="col-lg-12 col-md-12">
                                          <div className="form-group">
                                              <label for="exampleInputEmail1">Main System IP*</label>
                                              <div className="input-group input-group-sm">
                                                  <input type="text" id="network_ip" name="network_ip" className="form-control required" placeholder="" />
                                              </div>
                                          </div>
                                      </div>
                                  </div>
                                  <div className="col-md-6 respSSL"></div>
                                  <div id="testing2dd2222"></div>
                              </div>
                      </div>
                  </div>
              </div>
        </div>
        <div className="modal-footer">
        <div id="getReponse" style={{color:"red"}}></div>
          <button type="button" className="btn btn-secondary" data-dismiss="modal">Close</button>
          <button type="button" className="btn _btnSetColor btn-primary">Save Settings</button>
        </div>
        </form>
      </div>
      </div>
      </div>)
}

export default Add_Network_Comp;